// extracted by mini-css-extract-plugin
export var container = "_iw-0";
export var content = "_iw-3";
export var customerTitle = "_iw-4";
export var empty = "_iw-5";
export var gray = "_iw-6";
export var header = "_iw-7";
export var info = "_iw-8";
export var loading = "_iw-2";
export var loadingCard = "_iw-9";
export var oneLine = "_iw-a";
export var personName = "_iw-e";
export var pillContainer = "_iw-b";
export var selected = "_iw-1";
export var text = "_iw-c";
export var twoLines = "_iw-d";
export var unread = "_iw-f";
export var unreadIndicator = "_iw-g";